<!--
    Need to disable eslint so that it doesn't break content
    onto separate line from tag because we're preserving whitespace.
    Otherwise the whitespace added by eslint will be visible to the user
-->
<!-- eslint-disable vue/singleline-html-element-content-newline -->
<template>
    <div class="text-break multiline-text-content">{{ content }}</div>
</template>
<script>
    export default {
        props: {
            content: { type: String, required: true }
        }
    };
</script>
<style lang="scss" scoped>
    // Ensure we don't lose line breaks
    .multiline-text-content {
        white-space: pre-line;
    }
</style>
